import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

// pages
import LoginPage from '../pages/login'
import Error404Page from '../pages/Errors/404'

// layouts
import AdminLayout from '../layouts/admin'

// views
import DashboardView from '../views/dashboard'
import PrincipalView from '../views/principals'
import CustomerView from '../views/customer'
import SATView from '../views/sat'
import TerrritoryView from '../views/terrritory'
import UserManagementView from '../views/userManagement'
import DistrictView from '../views/district'
import NationalSalesView from '../views/nationalsales'
import RegionalSalesView from '../views/regionalSales'
import ReportsView from '../views/reports'

// reports child
import BinCardsChild from '../views/reports/childs/bincards'
import SalesReportChild from '../views/reports/childs/sales'
import DeliveryMonitoringChild from '../views/reports/childs/deliveryMonitoring'
import BillCollectorChild from '../views/reports/childs/billCollector'
import PDCCollectionChild from '../views/reports/childs/pdcCollection'
import InventoryLevelChild from '../views/reports/childs/inventoryLevel'
import ConsignmentOrderChild from '../views/reports/childs/consignmentOrder'
import PendingSalesOrderChild from '../views/reports/childs/pendingSalesOrder'
import PendingSalesOrderCSChild from '../views/reports/childs/pendingSalesOrderCS'
import GetDetailedAgingByPrincipalChild from '../views/reports/childs/detailedAgingByPrincipal'
import RSMTypeReportChild from '../views/reports/childs/rsmReportType'
import ReportLogs from '../views/reports/childs/logs'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Login',
        component: LoginPage
    },
    {
        path: '/',
        name: 'Admin',
        component: AdminLayout,
        children: [{
                path: 'dashboard',
                name: 'Dashboard',
                component: DashboardView,
            },
            {
                path: 'user',
                name: 'User',
                component: UserManagementView,
            },
            {
                path: 'principal',
                name: 'Principal',
                component: PrincipalView,
            },
            {
                path: 'sat',
                name: 'SAT',
                component: SATView,
            },
            {
                path: 'customer',
                name: 'Customer',
                component: CustomerView,
            },
            {
                path: 'district',
                name: 'District',
                component: DistrictView,
            },
            {
                path: 'nationalsales',
                name: 'National Sales',
                component: NationalSalesView,
            },
            {
                path: 'regionalSales',
                name: 'Regional Sales',
                component: RegionalSalesView,
            },
            {
                path: 'territory',
                name: 'Territory',
                component: TerrritoryView,
            },
            {
                path: 'reports',
                name: 'Reports',
                component: ReportsView,
                children: [{
                        path: 'bincards',
                        name: 'Bin Card',
                        component: BinCardsChild,
                    },
                    {
                        path: 'sales',
                        name: 'Sales',
                        component: SalesReportChild,
                    },
                    {
                        path: 'deliverymonitoring',
                        name: 'Delivery Monitoring',
                        component: DeliveryMonitoringChild,
                    },
                    {
                        path: 'billcollector',
                        name: 'Bill Collector',
                        component: BillCollectorChild,
                    },
                    {
                        path: 'pdccollection',
                        name: 'PDC Collection',
                        component: PDCCollectionChild,
                    },
                    {
                        path: 'logs',
                        name: 'Report Logs',
                        component: ReportLogs,
                    },
                ]
            },
            {
                path: 'reports-overview',
                name: 'Reports Overview',
                component: ReportsView,
                children: [
                    {
                        path: 'inventorylevel',
                        name: 'Inventory Level',
                        component: InventoryLevelChild,
                    },
                    {
                        path: 'consignmentorder',
                        name: 'Consignment Order',
                        component: ConsignmentOrderChild,
                    },
                    {
                        path: 'pendingsalesorder',
                        name: 'Pending Sales Order',
                        component: PendingSalesOrderChild,
                    },
                    {
                        path: 'pendingsalesordercs',
                        name: 'Pending Sales Order CS',
                        component: PendingSalesOrderCSChild,
                    },
                    {
                        path: 'detailedagingbyprincipal',
                        name: 'Detailed Aging By Principal',
                        component: GetDetailedAgingByPrincipalChild
                    },
                    {
                        path: 'rsmtypereport',
                        name: 'RSM Type Report',
                        component: RSMTypeReportChild,
                    }
                ]
            }
        ]
    },
    {
        path: '*',
        name: 'Error',
        component: Error404Page
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async(to, from, next) => {
    var token = await store.getters.token;
    // var sessionToken = sessionStorage.getItem('ors-token');

    // const params = new Proxy(new URLSearchParams(window.location.search), {
    //     get: (searchParams, prop) => searchParams.get(prop),
    // });
    // let paramsToken = params.token;

    const paramsToken = to.query.token || ''; // Get token from query parameters

    if (!token) {
        if(paramsToken) {
            // console.log("paramsToken");
            await store.dispatch("setToken", paramsToken, { root: true }).catch((error) => { });
            // console.log("paramsToken setToken");
            // token = paramsToken;
        }
    }
    
    // Old
    // if (to.path === '/') {
    //     if (token != '') {
    //         next("/dashboard");
    //     } else {
    //         next();
    //     }
    // } else {
    //     if (token != '') {
    //         next();
    //     } else {
    //         next("/");
    //     }
    // }

    // New 
if (paramsToken) {
    // next("/dashboard"); 
    // next({ name: 'Dashboard' }); 
    window.location.href = "/dashboard"; // Query Parameter Login
} else if (to.path === '/') {
    if (token != '') {
        // next("/dashboard");
        next({ name: 'Dashboard' }); // Manual Login 
    } else {
        next();
    }
} else {
    if (token != '' || sessionStorage.getItem('ors-token').length > 0) { // Session Storage Token is Added Here because Token value is not refreshed setToken.
        next();
    } else {
        next("/");
    }
}
});

export default router